export enum StatType {
  Percentage = "percentage",
  Count = "count",
}

export enum RedFlag {
  ALERTS = "ALERTS",
  NOTHING_TO_REPORT = "NOTHING_TO_REPORT",
}
